import $ from 'jquery';
import { showSidebarTab, toggleEditorSidebar } from '~src/sidebarLegacy';
import {
  updateTextBorderColorControl,
  updateTextBorderThicknessControl,
} from '~core/borders';
import { getState } from '~src/state';

export const toggleTextBorder = (event) => {
  // Event is optional: floating controls call without passing an event
  if (event && typeof event.preventDefault === 'function') {
    event.preventDefault();
  }
  const isSidebarOpen = getState('isSidebarOpen');
  const isTextBorderTabActive = $('#tab-text-border').hasClass('active');

  if (isSidebarOpen && isTextBorderTabActive) {
    // If sidebar is open and text border tab is already active, close sidebar
    toggleEditorSidebar();
  } else {
    // If sidebar is closed or showing different tab, show text border tab
    $('#sidebar-content .tab').removeClass('active');
    showSidebarTab('text-border');
    updateTextBorderColorControl();
    updateTextBorderThicknessControl();
  }
};
